
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hzK4Z", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ccb972f8f1c5733b$export$6503ec6e8aabbaf; }, function (v) { return $ccb972f8f1c5733b$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $ccb972f8f1c5733b$export$f7ad0328861e2f03; }, function (v) { return $ccb972f8f1c5733b$export$f7ad0328861e2f03 = v; });
var $ccb972f8f1c5733b$export$6503ec6e8aabbaf;
var $ccb972f8f1c5733b$export$f7ad0328861e2f03;
"use strict";
var $ccb972f8f1c5733b$var$mapping = new Map();
function $ccb972f8f1c5733b$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$ccb972f8f1c5733b$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $ccb972f8f1c5733b$var$resolve(id) {
    var resolved = $ccb972f8f1c5733b$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$ccb972f8f1c5733b$export$6503ec6e8aabbaf = $ccb972f8f1c5733b$var$register;
$ccb972f8f1c5733b$export$f7ad0328861e2f03 = $ccb972f8f1c5733b$var$resolve;

});

parcelRegister("4m9Pp", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $32c0d72e2f6110e1$export$bdfd709ae4826697; }, function (v) { return $32c0d72e2f6110e1$export$bdfd709ae4826697 = v; });
var $32c0d72e2f6110e1$export$bdfd709ae4826697;
var $32c0d72e2f6110e1$export$c9e73fbda7da57b6;
var $32c0d72e2f6110e1$export$5a759dc7a1cfb72a;
"use strict";
var $32c0d72e2f6110e1$var$bundleURL = {};
function $32c0d72e2f6110e1$var$getBundleURLCached(id) {
    var value = $32c0d72e2f6110e1$var$bundleURL[id];
    if (!value) {
        value = $32c0d72e2f6110e1$var$getBundleURL();
        $32c0d72e2f6110e1$var$bundleURL[id] = value;
    }
    return value;
}
function $32c0d72e2f6110e1$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $32c0d72e2f6110e1$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $32c0d72e2f6110e1$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $32c0d72e2f6110e1$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$32c0d72e2f6110e1$export$bdfd709ae4826697 = $32c0d72e2f6110e1$var$getBundleURLCached;
$32c0d72e2f6110e1$export$c9e73fbda7da57b6 = $32c0d72e2f6110e1$var$getBaseURL;
$32c0d72e2f6110e1$export$5a759dc7a1cfb72a = $32c0d72e2f6110e1$var$getOrigin;

});

var $1155c33ca90f4069$exports = {};


(parcelRequire("hzK4Z")).register((parcelRequire("4m9Pp")).getBundleURL("2GdYK"), JSON.parse('["2GdYK","confirmation-page.b83fb277.js","avTVb","dev.b584295f.js","7H9zx","Intro.d229ae0e.js","1gxHN","Outro.837860b5.js","fOXwx","EN02.38244805.js","jR1dY","EN03.b44bfc79.js","fygxg","EN04.cb380d08.js","f8QFu","DE02.1d7d3b19.js","f0hvp","DE03.0719494b.js","h8iSh","DE04.1df9e9fc.js","4Bo1q","FR02.99ff3239.js","jaGIj","FR03.7f5c8cc2.js","d5uGg","FR04.1a0f5f9a.js","aZWwn","ES02.4f1e50b0.js","aM7eQ","ES03.fbbce5c6.js","jxXZL","ES04.84636a3c.js","jbpwU","JA02.5eb2b3d3.js","3BL8n","JA03.7a1a4df4.js","gbGhY","JA04.89f590eb.js","iYtLx","PTBR02.55c3ac81.js","knDtL","PTBR03.e39b525a.js","4GGb6","PTBR04.adf70cee.js","gGYrV","1TAIL.1d0bc234.js","aFjZp","1TOP.a325e3b8.js","93HEw","2TAIL.08ec9328.js","bgHSP","2TOP.2a8a296d.js","jz4Fc","3TAIL.a3adcd9b.js","kdlH7","3TOP.327341dc.js","jJfVo","4TAIL.2e62d2ce.js","fFjTe","4TOP.c2c95f60.js","7XMft","5REFLOOP.6127c8ee.js","iUkan","6LOOP.23630173.js","5CtkU","7OUTRO.73720b8b.js","4CJmp","SlackTeamsSpotlight.bc23ff6d.js","bfdMI","Ed.61b780ab.svg","9sp2i","Katina.9d77d506.svg","e4KJR","Myra.6a2e56a8.svg","ha3Lb","Oliver.3c8edaab.svg","7kvHB","slackSpotlight.c7655f37.svg","4Q50U","esm.39a79998.js","dPOEd","main.99df641d.js","gPata","main.4d561572.js","5NThz","main.19bd45a1.js","e2mGI","main.fe2534a1.js","26fL5","main.9bdfb404.js","dXqDX","cs.4ef6a263.js","2IQIl","da.a230973d.js","gJw2T","de.09526b5f.js","jJphk","en.2bd83ec8.js","cDSwz","en_GB.261b7744.js","efaQt","en_ZZ.c8dd995b.js","9dFJe","es.4d64b54d.js","l8I05","et.5738fc7a.js","iJb0K","fi.32f97190.js","7I626","fr.446acad6.js","9p35U","hu.162679a9.js","23E9a","is.3aaa316f.js","8ST8j","it.afd5abab.js","3Kf9K","ja.c44bd97d.js","i3ZnS","ko.ad534756.js","aR8BM","nb.03a38c68.js","d3s11","nl.5159a679.js","gqFPQ","pl.dbe62b59.js","iz2sQ","pt_BR.4e6779da.js","gPwxo","pt_PT.a1d4eaff.js","hcbyJ","ro.5974fa42.js","j3bHi","ru.dc500927.js","5l1Pc","sk.0968082b.js","iZ2D7","sv.6c62d5de.js","35CjR","th.0926dde0.js","dxKn1","tr.04de74b1.js","6NOFj","uk.e8c18442.js","lGDFP","vi.66b12db4.js","cTLIv","zh_TW.72149b1d.js","7bpaL","zh.b6722813.js","gFXCL","cs.c78047e5.js","a0CyL","da.d8911ce0.js","lwbBP","de.1ec11555.js","5PMAN","en_GB.132165c2.js","7n3cs","en.1cda3e09.js","ejDYf","en_ZZ.c704f573.js","bP5kS","es.8799b268.js","6bpJR","fi.4c769b64.js","gvR4T","fr.eb5dbdd5.js","aKAbs","hu.861e2363.js","e2dRf","it.11e9b6e4.js","hApoz","ja.7c7d1234.js","1cUdo","ko.6a200510.js","iSvVQ","nb.9cb2ad13.js","bgdVr","nl.8884b9e5.js","fUVA2","pl.ea8aa9b8.js","eHdK1","pt_BR.a520b542.js","8fdnq","ru.2d4c54a3.js","2U5bS","sv.b93ed850.js","hLrPT","tr.cd29fdac.js","1GHIP","th.a9d87fff.js","hbIgY","uk.7d427a2b.js","7Ani5","vi.d499274d.js","fNZgp","zh_TW.2d119903.js","3v6lJ","zh.2f99532f.js","fmO23","cs.2c110338.js","4aRg0","da.6b353cbf.js","kyMTl","de.ffd5a409.js","93JbF","en_GB.b92db0c3.js","9tpWp","en.54b3e593.js","aiXxe","en_ZZ.4348e777.js","86jbk","es.78b84bf0.js","6OI84","et.c44edfc9.js","aNn8C","fi.42377b7b.js","aobIS","fr.1b549619.js","ejByz","hu.47a086ff.js","hdwLB","is.1b4b45a4.js","i6oZX","it.ab880c13.js","lSflO","ja.5b3da4ba.js","cinW4","ko.a078bf9f.js","jkFMz","nb.8dfd969e.js","fpsDK","nl.01869d46.js","deJ1K","pl.d7394642.js","4AbGv","pt_BR.023ca323.js","dmTET","pt_PT.65d81bf7.js","17glB","ro.0ac84de7.js","icIuX","ru.a704f36d.js","fjxvo","sk.2c25a0b4.js","6fOjm","sv.f9560afa.js","3ZdZ6","tr.db768f70.js","3BG6h","th.129b977a.js","18RH6","uk.5cb25de2.js","jCQvc","vi.66024bc9.js","IcbGP","zh_TW.90ea680a.js","efiTz","zh.9325f0fc.js","fpj7G","WarningIllustration.d6a92eb7.js","kTKcP","WarningIllustration.08581ce9.png"]'));


//# sourceMappingURL=confirmation-page.runtime.25f9b0d3.js.map
